import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ReportContent from '../components/pages/reports/main-Report/content';
import NotFoundPage from './NotFoundPage.js';
import moment from 'moment';
export default function ReportPage(props) {
  const dispatch = useDispatch();
  // Extract from logic mapStateToProps
  const userId = useSelector((state) => state.usersReducer.userProfile.id);
  const maxOrgCountForAutoLoad = useSelector((state) => state.usersReducer.userProfile.orgNumberToAllowAutoLoadReport);
  // end
  const redirectToPageNotFound = useSelector((state) => state.sharedReducer.redirectToPageNotFound);
  const reports = useSelector((state) => state.reportReducer.reports);
  const hasReports = useSelector((state) => state.usersReducer.userProfile.hasReports);
  const timezone = useSelector((state) => state.usersReducer.userProfile.timezoneOffsetNow);
  const fetchingReports = useSelector((state) => state.reportReducer.fetchingReports);
  const hideDataOutdateWarning = useSelector((state) => state.reportReducer.hideDataOutdateWarning);
  const minConsultationDurValue = useSelector((state) =>
    window.localStorage && window.localStorage.getItem(`minConsultationDur-${userId}`)
      ? parseInt(window.localStorage.getItem(`minConsultationDur-${userId}`), 10)
      : state.reportReducer.minConsultationDurValue
  );
  const minMeetingDurValue = useSelector((state) =>
    window.localStorage && window.localStorage.getItem(`minMeetingDur-${userId}`)
      ? parseInt(window.localStorage.getItem(`minMeetingDur-${userId}`), 10)
      : state.reportReducer.minMeetingDurValue
  );
  const showSetMinDurationsModal = useSelector((state) => state.modalReducer.showSetMinDurationsModal);
  const isAdmin = useSelector((state) => state.usersReducer.userProfile && state.usersReducer.userProfile.isAdmin);
  const hasMoreThanOneOrg = useSelector(
    (state) =>
      state.usersReducer.userProfile &&
      state.usersReducer.userProfile.organisations &&
      state.usersReducer.userProfile.organisations.length > (maxOrgCountForAutoLoad || 1)
  );
  //Start end date logic
  const { startDate, endDate } = useSelector((state) => {
    let hasMoreThanOneOrg =
      state.usersReducer.userProfile &&
      state.usersReducer.userProfile.organisations &&
      state.usersReducer.userProfile.organisations.length > (maxOrgCountForAutoLoad || 1);
    let startDate = state.reportReducer.startDate && moment(state.reportReducer.startDate);
    let endDate = state.reportReducer.endDate && moment(state.reportReducer.endDate);
    if (!hasMoreThanOneOrg) {
      startDate =
        window.localStorage && window.localStorage.getItem('startDateForReport')
          ? window.localStorage.getItem('startDateForReport')
          : startDate ||
            (state.usersReducer.userProfile.id &&
              state.usersReducer.userProfile.id > 0 &&
              moment().utcOffset(state.usersReducer.userProfile.timezoneOffsetNow).startOf('month')) ||
            moment().startOf('month');
      endDate =
        window.localStorage && window.localStorage.getItem('endDateForReport')
          ? window.localStorage.getItem('endDateForReport')
          : endDate ||
            (state.usersReducer.userProfile.id &&
              state.usersReducer.userProfile.id > 0 &&
              moment().utcOffset(state.usersReducer.userProfile.timezoneOffsetNow).endOf('month')) ||
            moment().endOf('month');
      // Convert startDate & endDate to moment object
      startDate = moment.isMoment(startDate) ? startDate : moment(startDate);
      endDate = moment.isMoment(endDate) ? endDate : moment(endDate);
    }
    return { startDate, endDate };
  });
  if (redirectToPageNotFound || hasReports) {
    return (
      <div>
        <ReportContent
          reports={reports}
          hasReports={hasReports}
          timezone={timezone}
          fetchingReports={fetchingReports}
          hideDataOutdateWarning={hideDataOutdateWarning}
          minConsultationDurValue={minConsultationDurValue}
          minMeetingDurValue={minMeetingDurValue}
          startDate={startDate}
          endDate={endDate}
          showSetMinDurationsModal={showSetMinDurationsModal}
          dispatch={dispatch}
          isAdmin={isAdmin}
          hasMoreThanOneOrg={isAdmin || hasMoreThanOneOrg}
        />
      </div>
    );
  } else if (hasReports === false) {
    return <NotFoundPage dispatch={props.dispatch} />;
  } else {
    // We need to use this, otherwise the NotFoundPage will flash before showing the report tiles
    return '';
  }
}
